import { ModulesMap } from '@/config/data/modulesMaps'
import MachineBrigadeApi from '@/services/apiServiceModules/machineBrigadeApi'
import DataTransferModule from '@/services/dataTransferModule'

const machineBrigadeApi = new MachineBrigadeApi()

export default class MachineBrigadeDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.MACHINE_BRIGADE, machineBrigadeApi, {
			hasParentEntity: true,
		})
	}
}
